
import ElementUI from 'element-ui';
const divMethods = {
  install:function(Vue){
    Vue.prototype.confirm = () => {
      return new Promise((resolve) => {
        ElementUI.MessageBox.confirm(`确认保存该信息？`, '提示', {
          type: 'info'
        }).then(() => {
          resolve(1)
        }).catch(() => {
          resolve(0)
        })
      }) 
    }

  }
}
// 导出
export default divMethods